export default __webpack_public_path__ + "static/media/MoreIcon.b9757ed3.svg";